var map = {
	"./de.json": 2509,
	"./en.json": 7323,
	"./en_GB.json": 9577,
	"./es.json": 8882,
	"./fr.json": 7699,
	"./it.json": 6798,
	"./pl.json": 1501,
	"./pt.json": 131,
	"./sv.json": 3748,
	"./uk.json": 5968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5022;